module.exports = __webpack_public_path__ + "static/media/darkBackground.bfda5a2c.png";